import { axiosSecuredInstance } from "configurations/axiosConfig";
import { PolicyActivityEntry } from "entities/UIModel/PolicyManagementRecord";
import { showToast } from "controls/global/stewart-toast";

// Mirrors Stewart.Shared.Entities.PolicyData.PolicyActivity (list endpoint
// returns PaginatedPolicyActivity, which extends it). PascalCase on the wire
// because Startup.cs sets JsonSerializerOptions.PropertyNamingPolicy = null.
export type PolicyActivityDto = {
  PolicyActivityID?: number | null;
  PolicyHistoryID?: number | null;
  PolicyTransactionID?: number | null;
  PolicyNumber?: string | null;
  ActingUserID?: string | null;
  ActingUser?: string | null;
  PolicyActivityTypeCode?: string | null;
  PolicyActivityTypeName?: string | null; // read-only, from PolicyActivityType join
  SubType?: string | null;
  ActivityDate?: string | null; // DateTimeOffset
  Description?: string | null;
  FromStage?: string | null;
  ToStage?: string | null;
  FieldName?: string | null;
  OldValue?: string | null;
  NewValue?: string | null;
  PolicyErrorTypeCode?: string | null;
  PolicyErrorTypeName?: string | null;
  Notes?: string | null;
};

// [PolicyActivity_GetListByTransaction] requires PolicyTransactionID.
export type PolicyActivityCriteriaDto = {
  PolicyTransactionID: number;
  UserTimeZone: string;
  SortColumn?: string;
  ListCount?: number;
  RequestedPage?: number;
};

export const mapActivityDtoToEntry = (
  dto: PolicyActivityDto
): PolicyActivityEntry => ({
  policyActivityTypeCode: dto.PolicyActivityTypeCode ?? "",
  description: dto.Description ?? dto.PolicyActivityTypeName ?? "",
  by: dto.ActingUser ?? "",
  at: dto.ActivityDate ?? "",
  notes: dto.Notes ?? "",
  from: dto.FromStage ?? "",
  to: dto.ToStage ?? "",
});

export const getPolicyActivityListByTransaction = async (
  criteria: PolicyActivityCriteriaDto
): Promise<PolicyActivityDto[]> => {
  try {
    const { data } = await axiosSecuredInstance.post<PolicyActivityDto[]>(
      "/PolicyActivity/GetPolicyActivityListByTransaction",
      criteria
    );
    return Array.isArray(data) ? data : [];
  } catch {
    showToast({ type: "error", message: "Failed to load history." });
    return [];
  }
};
